import { Panel, Textbox } from "@mcleod/components";
import { getDispatchControlValue } from "@mcleod/general";

export class TrailerUtil {

    static setupMaxTrailers(trailer1: Textbox, trailer2: Panel | Textbox, trailer3: Panel | Textbox) {
        const maxTrailers = getDispatchControlValue("maximum_trailers");
        if (maxTrailers) {
            trailer1?.setProps({ caption: maxTrailers > 1 ? "Trailer 1" : "Trailer" });
            trailer2?.setProps({ visible: maxTrailers > 1 });
            trailer3?.setProps({ visible: maxTrailers > 2 });
        }
    }

}
